<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle :title="title" />
    </b-col>
    <b-col cols="12">
      <slot />
    </b-col>
  </b-row>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';

export default {
  name: 'BaseView',
  props: {
    title: {
      type: String,
      default: 'Sem nome',
      required: true,
    }
  },
  components: {
    PageTitle,
  },
};
</script>